<template>
  <div>
    <label class="dbc-gc-form__label" :for="$t('dbc-label-mobile-phone')"
      >{{ $t('dbc-label-mobile-phone') }}*</label
    >
    <div class="c-phone-number__group">
      <FormKit
        type="select"
        name="country"
        :value="country"
        @input="(value: string) => emit('update:country', value as string)"
        :options="countries ?? ['DE']"
        validation="required"
        inner-class="w-[5em] h-[43px]"
      />
      <FormKit
        type="tel"
        name="phoneNumber"
        validation="required|number|parsePhoneNumber"
        :validation-rules="{ parsePhoneNumber }"
        :id="$t('dbc-label-mobile-phone')"
        :placeholder="$t('dbc-placeholder-mobile-phone')"
        outer-class="c-phone-number"
        :value="phoneNumber"
        @input="(value: string) => emit('update:phoneNumber', value as string)"
        :validation-messages="{
          required: `${$t('dbc-label-mobile-phone')} ${$t(
            'dbc-error-invalid'
          )}`,
          number: `${$t('dbc-label-mobile-phone')} ${$t('dbc-error-invalid')}`,
          parsePhoneNumber: `${$t('dbc-label-mobile-phone')} ${$t(
            'dbc-error-invalid'
          )}`,
        }"
        autocomplete="tel-national"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FormKitNode } from '@formkit/core'
import type { ParsedPhoneNumber } from 'awesome-phonenumber'

defineProps<{
  country: string
  phoneNumber: string
}>()

const emit = defineEmits<{
  (e: 'onPhoneValidation', parsedPhoneNumber: ParsedPhoneNumber): void
  (e: 'update:country', country: string): void
  (e: 'update:phoneNumber', phoneNumber: string): void
}>()

const { $parsePhoneNumber } = useNuxtApp()

const parsePhoneNumber = (node: FormKitNode) => {
  const phonenumber: string = node.value as string
  const regionCode: string = node.at('country')?.value as string
  const pn: ParsedPhoneNumber = $parsePhoneNumber(phonenumber, { regionCode })
  emit('onPhoneValidation', pn)
  return pn.valid && pn.typeIsMobile
}

const countries = await useFetchCountries()
</script>
